"use client";
import { PaylioContext } from "@/context/context";
import Image from "@/components/AppImage";
import { useContext } from "react";
import PaymentCard from "../cards/PaymentCard";
import bank_account_icon from "/public/images/icon/bank-account-icon.png";
import paylio_account_icon from "/public/images/icon/paylio-account-icon.png";
import support_icon from "/public/images/icon/support-icon.png";

const paymentData = [
  {
    id: 1,
    icon: paylio_account_icon,
    title: "Send USDC on Polygon",
    pay: "From your default USDC balance",
    link: "/pay/step-1",
  },
  {
    id: 2,
    icon: bank_account_icon,
    title: "Off-ramp to your linked bank",
    pay: "USDC → ACH payout (settlement)",
    link: "/withdraw-money/step-1",
  },
];

const PayMain = () => {
  const { activeLefMenu } = useContext(PaylioContext);
  return (
    <section
      className={`dashboard-section ${
        activeLefMenu ? "body-collapse" : ""
      } pay`}>
      <div className="overlay pt-120">
        <div className="container-fruid">
          <div className="main-content">
            <div className="head-area d-flex align-items-center justify-content-between">
              <div>
                <h4>Move funds</h4>
                <p className="mdr mb-0 mt-2">
                  Inbound funding is ACH only. Spending uses your Polygon USDC
                  (default) or optional POL after auto-convert.
                </p>
              </div>
              <div className="icon-area">
                <Image src={support_icon} alt="icon" />
              </div>
            </div>
            <div className="row pb-120">
              {paymentData.map((itm) => (
                <div key={itm.id} className="col-xxl-3 col-xl-4 col-md-5">
                  <PaymentCard data={itm} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayMain;
